import request from "@/utils/request";

export const systemNotificationEditApi = (data) =>
  request("/mtsV2/systemNotification/edit", {
    method: "POST",
    data,
  });

export const systemNotificationListApi = (data) =>
  request("/mtsV2/systemNotification/queryList", {
    method: "POST",
    data,
  });

export const systemNotificationDetailApi = (params) =>
  request("/mtsV2/systemNotification/detail", {
    method: "GET",
    params,
  });

export const systemNotificationDeleteApi = (params) =>
  request("/mtsV2/systemNotification/delete", {
    method: "GET",
    params,
  });

export const systemNotificationReleaseApi = (params) =>
  request("/mtsV2/systemNotification/release", {
    method: "GET",
    params,
  });

export const systemNotificationGetUserNotReadDataCountApi = (params) =>
  request("/mtsV2/systemNotification/getUserNotReadDataCount", {
    method: "GET",
    params,
  });

export const systemNotificationQueryUserDataListApi = (data) =>
  request("/mtsV2/systemNotification/queryUserDataList", {
    method: "POST",
    data,
  });

export const systemNotificationGetUserCanPopupDataApi = (params) =>
  request("/mtsV2/systemNotification/getUserCanPopupData", {
    method: "GET",
    params,
  });

export const systemNotificationConfirmApi = (params) =>
  request("/mtsV2/systemNotification/confirm", {
    method: "GET",
    params,
  });

export const systemNotificationQueryReleasedUserListApi = (data) =>
  request("/mtsV2/systemNotification/queryReleasedUserList", {
    method: "POST",
    data,
  });
